import { render } from "./HeroSwiper.vue?vue&type=template&id=735f565b"
import script from "./HeroSwiper.vue?vue&type=script&lang=js"
export * from "./HeroSwiper.vue?vue&type=script&lang=js"

import "./HeroSwiper.vue?vue&type=style&index=0&id=735f565b&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ContentCreator/Hero/HeroSwiper.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "735f565b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('735f565b', __exports__)) {
    api.reload('735f565b', __exports__)
  }
  
  module.hot.accept("./HeroSwiper.vue?vue&type=template&id=735f565b", () => {
    api.rerender('735f565b', render)
  })

}


export default __exports__